import React, { useState, useEffect } from "react";
import { parseCompetitionDate } from "@/utils/DateFormatter";

// Tipos para representar el tiempo restante
interface TimeLeft
{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

// Props del componente
interface CountdownTimerProps
{
    startDate: string; // Fecha de inicio
    endDate: string;   // Fecha de fin
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ startDate, endDate }) =>
{
    // Fechas a medianoche local; null si el API envía algo no interpretable
    const start = parseCompetitionDate(startDate);
    const end = parseCompetitionDate(endDate);

    // Estado inicial (loading)
    const [isLoading, setIsLoading] = useState(true);
    const [timeRemaining, setTimeRemaining] = useState<TimeLeft | null>(null);
    const [status, setStatus] = useState<string>("");

    // Cálculo del tiempo restante
    function calculateTimeLeft(target: Date): TimeLeft
    {
        const now = new Date();
        const difference = target.getTime() - now.getTime();

        if(difference > 0)
        {
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / (1000 * 60)) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        else
        {
            return { days: 0, hours: 0, minutes: 0, seconds: 0 }; // Tiempo agotado
        }
    }

    // Actualiza el estado del contador y la lógica del estado
    useEffect(() =>
    {
        const timer = setInterval(() =>
        {
            const now = new Date();

            // Con fechas no interpretables se cae en "Competición finalizada", igual que antes con Invalid Date
            if(start !== null && now < start)
            {
                setTimeRemaining(calculateTimeLeft(start));
                setStatus("Empieza en");
            }
            else if(start !== null && end !== null && now >= start && now < end)
            {
                setTimeRemaining(calculateTimeLeft(end));
                setStatus("Acaba en");
            }
            else
            {
                setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                setStatus("Competición finalizada");
            }

            // Después de determinar el estado, se apaga el loading
            setIsLoading(false);

        }, 1000);

        return () => clearInterval(timer); // Limpia el intervalo
    }, [start, end]);

    if(isLoading)
    {
        return(
            <div style={{textAlign: "center", color: "#cc214f"}}>
                <p>Cargando...</p>
            </div>
        );
    }

    return(
        <div style={{textAlign: "right", color: "#cc214f", marginTop: "16px"}}>
            <div>
                {status !== "Competición finalizada" ?
                (
                    <>
                        {status}&nbsp;
                        <b>
                            {timeRemaining?.days}D {" "} {timeRemaining?.hours}H
                            {" "}{timeRemaining?.minutes}M  {" "}{timeRemaining?.seconds}S
                        </b>
                    </>
                ) :
                (
                    <b>{status}</b>
                )}
            </div>
        </div>
    );
};

export default CountdownTimer;